/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".offline[_ngcontent-%COMP%], .online[_ngcontent-%COMP%]{height:24px;line-height:24px;color:#fff;text-align:center;-webkit-box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.online[_ngcontent-%COMP%]{background:#7ed321}.offline[_ngcontent-%COMP%]{background:#f5a623}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/offline-indicator/offline-indicator.component.scss.shim.ngstyle.js.pre-build-optimizer.js